import { connect } from 'react-redux';
import Orders from '../../components/orders/Orders';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Orders);
